import React from "react";
import { Quote } from "lucide-react";

const ITEMS = [
    {
        quote: "BPO Solutions gave our scaleup the operating muscle of a much larger company — without the bureaucracy. Six Sigma rigour delivered with a startup mindset.",
        author: "Founder & CEO",
        role: "B2B SaaS scaleup · EU",
    },
    {
        quote: "Prosci-led change adoption finally connected our transformation programme to the people on the ground. Outcomes followed within a quarter.",
        author: "Chief Operating Officer",
        role: "Mid-sized services firm · BeNeLux",
    },
    {
        quote: "Vested® framing reshaped our key supplier partnership into a true outcome model. Trust, value and accountability all moved up together.",
        author: "Head of Procurement",
        role: "Energy sector SME · Bulgaria",
    },
];

export default function Testimonials() {
    return (
        <section
            data-testid="testimonials-section"
            className="relative py-24 md:py-32 bg-white"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="max-w-3xl mb-14">
                    <span className="eyebrow text-bpo-cyanDark">
                        Voices from our engagements
                    </span>
                    <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-bpo-ink leading-[1.05]">
                        What partners say after working with us.
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {ITEMS.map((t, i) => (
                        <figure
                            key={i}
                            data-testid={`testimonial-${i}`}
                            className="relative rounded-3xl border border-gray-200 bg-gray-50 p-8 md:p-9 flex flex-col gap-6"
                        >
                            <Quote className="h-7 w-7 text-bpo-cyan" />
                            <blockquote className="font-display text-lg md:text-xl font-medium tracking-tight text-bpo-ink leading-snug">
                                “{t.quote}”
                            </blockquote>
                            <figcaption className="mt-auto">
                                <div className="font-semibold text-bpo-ink text-sm">
                                    {t.author}
                                </div>
                                <div className="text-xs uppercase tracking-[0.18em] text-gray-500 mt-1 font-semibold">
                                    {t.role}
                                </div>
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
